import { useEffect, useRef } from 'react';
import { createPhaserGame } from './createPhaserGame';

function PhaserGame({
  createConfig,
  className = '',
  ariaLabel = 'Phaser game canvas',
}) {
  const containerRef = useRef(null);
  const gameRef = useRef(null);
  const mountIdRef = useRef(0);

  useEffect(() => {
    let cancelled = false;
    const mountId = mountIdRef.current + 1;
    mountIdRef.current = mountId;
    const container = containerRef.current;

    async function mountGame() {
      if (!container) {
        return;
      }

      // Clear out stale children so route remounts never stack canvases.
      container.replaceChildren();

      const game = await createPhaserGame({
        createConfig,
        parent: container,
      });

      if (cancelled || mountId !== mountIdRef.current) {
        game.destroy(true, false);
        game.canvas?.remove?.();
        return;
      }

      const canvases = Array.from(container.querySelectorAll('canvas'));
      canvases
        .filter((canvas) => canvas !== game.canvas)
        .forEach((canvas) => canvas.remove());
      gameRef.current = game;
    }

    mountGame();

    return () => {
      cancelled = true;

      if (gameRef.current) {
        gameRef.current.destroy(true, false);
        gameRef.current = null;
      }

      container?.replaceChildren();
    };
  }, [createConfig]);

  return (
    <div
      aria-label={ariaLabel}
      className={className}
      ref={containerRef}
      role="application"
    />
  );
}

export default PhaserGame;
